<template>
    <div class="t-wrapperNews t-mainInsideContainer">
        <div class="t-insideBgHolder">
            <div class="t-insideBgHolderOverlay">
                <h3 class="t-insideBgHolderTitle">Новости</h3>
            </div>
        </div>
        <div class="t-container">
            <div class="t-loadedData">
                <!-- <div class="t-newsCardsHolder"> -->
                <transition-group tag="div" class="t-newsCardsHolder">
                    <news-card :news="item" v-for="(item, index) in news" :key="index"></news-card>
                </transition-group>
                <!-- </div> -->
                <button  v-if="loadMoreBtn" @click.stop.prevent="loadMoreItems()" class="t-btn t-moreBtn">Больше новостей</button>
            </div>
        </div>
        <router-view :route="path"></router-view>
    </div>
</template>



<script>
    import Vue from 'vue'
    import { store } from '../../../store';
    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';
    export default {
        metaInfo: {
            title: 'Новости',
        },
        data() {
            return {
                path: this.$router.currentRoute.matched[0].path
            }
        },
        computed: {
            ...mapGetters('newsStore',  {
                news: 'loadedNews',
                loadMoreBtn: 'loadMoreBtn'
            }),
            // news() {return this.$store.getters.loadedNews},
            loading() {return this.$store.getters.loading;},
        },
        methods:{
            ...mapActions('newsStore', {
                loadNews: 'loadNews',
                loadMore: 'loadMore',
                clearItems: 'clearItems'
            }),
            ...mapActions({
                load: 'load'
            }),
            loadItems(data){
                this.setItems(data).then(
                    this.load()
                )
            },
            loadMoreItems(){
                let offset = parseInt(this.$route.query.offset) || 6;
                offset += 6;
                Vue.http.get('/api/news.json',  {params:{"offset": offset}})
                    .then(response => response.json())
                    .then(data => {
                        this.$router.push({ query: { ...this.$route.query, offset: offset }});
                        this.loadMore(data)
                    });
            }
        },
        beforeRouteEnter(to, from, next) {
            let offset = parseInt(to.query.offset) || 6;
            Vue.http.get('/api/news.json',  {params:{"offset": offset}})
                .then(response => response.json())
                .then(json => {
                    next(
                        vm => {
                            // vm.$router.push({ query: { ...vm.$route.query, offset: offset }});
                            // vm.clearItems();
                            // vm.loadMore(json);
                            vm.loadNews(json)
                            }
                    );
                })
        },
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/vue_components/InsidePages/News/News.vue